import { useEffect, useRef } from "react";
import { Bold, Heading2, Heading3, List, ListOrdered, Link2, Image, Pilcrow } from "lucide-react";

export default function MiniEditor({ value, onChange, testId }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const emit = () => onChange(ref.current.innerHTML);
  const exec = (cmd, arg = null) => { ref.current.focus(); document.execCommand(cmd, false, arg); emit(); };
  const addLink = () => { const u = window.prompt("Link URL (https://…)"); if (u) exec("createLink", u); };
  const addImage = () => { const u = window.prompt("Image URL (https://…)"); if (u) exec("insertImage", u); };

  return (
    <div className="border border-neutral-300 focus-within:border-rust transition-colors">
      <div className="flex items-center gap-1 border-b border-neutral-200 px-2 py-1.5 bg-neutral-50 flex-wrap">
        <T onClick={() => exec("formatBlock", "h2")} title="Heading"><Heading2 className="w-4 h-4" /></T>
        <T onClick={() => exec("formatBlock", "h3")} title="Subheading"><Heading3 className="w-4 h-4" /></T>
        <T onClick={() => exec("formatBlock", "p")} title="Paragraph"><Pilcrow className="w-4 h-4" /></T>
        <span className="w-px h-4 bg-neutral-300 mx-1" />
        <T onClick={() => exec("bold")} title="Bold"><Bold className="w-4 h-4" /></T>
        <span className="w-px h-4 bg-neutral-300 mx-1" />
        <T onClick={() => exec("insertUnorderedList")} title="Bullet list"><List className="w-4 h-4" /></T>
        <T onClick={() => exec("insertOrderedList")} title="Numbered list"><ListOrdered className="w-4 h-4" /></T>
        <span className="w-px h-4 bg-neutral-300 mx-1" />
        <T onClick={addLink} title="Insert link"><Link2 className="w-4 h-4" /></T>
        <T onClick={addImage} title="Insert image by URL"><Image className="w-4 h-4" /></T>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        data-testid={testId}
        onInput={emit}
        className="min-h-[220px] p-4 text-sm text-neutral-800 leading-relaxed outline-none [&_h2]:text-xl [&_h2]:font-medium [&_h2]:mt-4 [&_h2]:mb-2 [&_h3]:text-base [&_h3]:font-medium [&_h3]:mt-3 [&_h3]:mb-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-2 [&_a]:text-rust [&_a]:underline [&_img]:max-w-full"
      />
    </div>
  );
}

function T({ onClick, title, children }) {
  return (
    <button
      type="button"
      title={title}
      onMouseDown={(e) => { e.preventDefault(); onClick(); }}
      className="p-1.5 text-neutral-600 hover:text-ink hover:bg-neutral-100 rounded transition-colors"
    >
      {children}
    </button>
  );
}
